export const SQUARE_PAYMENT_LINK = "https://square.link/u/Lw7v1MJT";

export const WEBSITE_URL = "https://theironmountain.com";

export const SOCIAL_MEDIA_LINKS = {
  FACEBOOK: "https://www.facebook.com/share/15TiHNzqoa/",
  SPOTIFY: "https://open.spotify.com/track/0CmkKLUe9DnKQ486LeSYWg?si=dalL1s9_TnSZRsy4saxsag",
  TIKTOK: "https://www.tiktok.com/@russeldinizmusic",
  YOUTUBE: "https://www.youtube.com/@RusselDinizMusic",
  INSTAGRAM: "https://www.instagram.com/russeldinizmusic",
};

export const SONG_REQUEST_TYPES = {
  SING_FOR_ME: "singForMe",
  SING_WITH_YOU: "singWithYou",
  SING_ALONE: "singAlone",
};
